import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { FF2, TextInput, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const PriorReportBSAId = () => {
  const { control } = useFormContext<SarEdit>()

  const filingType = useWatch({ control, name: 'generalInfo.filingType' })

  return (
    <Controller
      name="generalInfo.priorReportBsaId"
      control={control}
      rules={{
        validate: (value) =>
          filingType.includes('filingTypeCorrectAmend') || filingType.includes('filingTypeContinuing')
            ? Validators.required.field(value)
            : undefined
      }}
      render={({ field }) => (
        <FF2
          required={filingType.includes('filingTypeCorrectAmend') || filingType.includes('filingTypeContinuing')}
          label="Prior report BSA Identifier"
          field={field}
          input={(props) => (
            <TextInput {...props} maxLength={14} disabled={filingType?.includes('filingTypeInitial')} />
          )}
        />
      )}
    />
  )
}
